import { render, staticRenderFns } from "./BotoesProposta.vue?vue&type=template&id=3f492488&"
import script from "./BotoesProposta.vue?vue&type=script&lang=js&"
export * from "./BotoesProposta.vue?vue&type=script&lang=js&"
import style0 from "./BotoesProposta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports